import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import Card from 'src/components/Cards/Card';
import 'stylesheets/components/college-success/add-to-portfolio-card.scss';

const propTypes = {
  emoji: PropTypes.string,
  title: PropTypes.string.isRequired,
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

const AddToPortfolioCard = ({emoji, title, link}) => (
  <Card className="add-to-portfolio-card" size="small">
    {emoji && <div className="add-to-portfolio-card-emoji">{emoji}</div>}
    <p className="add-to-portfolio-card-title">{title}</p>
    <Link className="add-to-portfolio-card-button" to={link}>
      Add to Portfolio
    </Link>
  </Card>
);

AddToPortfolioCard.propTypes = propTypes;

export default AddToPortfolioCard;
